<template>
  <ProgressDots style="font-size:15px;" :step="step" :steps="[
      'Create your account',
      'Setup your portal',
      'Upload your design',
      'Share with your team'
  ]"/>
</template>

<script>
export default {
  props: {step: {default: 1}}
}
</script>



// WEBPACK FOOTER //
// src/components/shared/SignUpProgress.vue